"use client";

import React from "react";
import type { GamificationCardBlock as GamificationCardBlockData } from "@/payload-types";
import type { GamificationType } from "@/features/gamification/GamificationWrapper";
import { GamificationWrapper, WidgetTemplate } from "@/features/gamification/GamificationWrapper";
import { useTenantSettings } from "@/lib/tenant/TenantSettingsProvider";
import { cn } from "@/utilities/core/cn";

interface GamificationCardBlockProps {
    block: GamificationCardBlockData;
    className?: string;
}

const TEMPLATE_MAP: Record<string, WidgetTemplate> = {
    standard: WidgetTemplate.STANDARD,
    split: WidgetTemplate.SPLIT,
    overlay: WidgetTemplate.OVERLAY,
};

export function GamificationCardBlock({ block, className }: GamificationCardBlockProps) {
    const { gamification } = useTenantSettings();
    const gameId = block.gameId;
    const gameType = block.gameType as GamificationType;
    const variant = block.variant || "standard";
    const template = TEMPLATE_MAP[variant] || WidgetTemplate.STANDARD;

    if (!gamification.enabled) return null;
    if (!gameId || !gameType) return null;

    return (
        <section className={cn("not-prose mb-6", className)}>
            <GamificationWrapper type={gameType} id={gameId} template={template} />
        </section>
    );
}
